
































































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import SelectStadium from "@/components/selectstadium.vue";

@Component({
  components: {
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  dispatchType = "users/coupon";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "标题", dataIndex: "title" },
    { title: "领取时间", dataIndex: "received_time" },
    { title: "过期时间", dataIndex: "expired_time" },
    { title: "金额", scopedSlots: { customRender: "fee" } },
    { title: "状态", scopedSlots: { customRender: "invalid_status" } },
    { title: "来源", scopedSlots: { customRender: "from_source" } },
    { title: "场馆", dataIndex: "stadium_name" },
    { title: "名称", dataIndex: "discount_title" },
    { title: "描述", scopedSlots: { customRender: "discount_desc" } }
  ];

  mounted() {
    this.loadData(
      {
        user_id: this.userId
      },
      false
    );
  }
}
